module.exports = function() {
  return new Worker(__webpack_public_path__ + "24bae0c1808a6bcf9421.worker.js");
};